export default __webpack_public_path__ + "static/media/HFI-HUSD.599a7f48.png";